import React from "react";
import CheckDetail from "./CheckDetail";
import Header from "./Header";
import { connect } from "react-redux";
import { startSetSymlinkCheck } from "../actions/checks";

class Symlink extends React.Component {
  componentDidMount() {
    this.props.startSetSymlinkCheck(this.props.match.params.token);
  }

  render() {
    return (
      <div className="route-container">
        <Header publicHeader={!this.props.isAuthenticated} />
        <div className="page">
          {this.props.symlinkMonitor && (
            <CheckDetail
              id={`${this.props.symlinkMonitor.id}`}
              isShare={true}
            />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  isAuthenticated: !!state.auth.uid,
  symlinkMonitor: state.checks.find(
    (el) => el.token === props.match.params.token
  ),
});

const mapDispatchToProps = (dispatch) => ({
  startSetSymlinkCheck: (token) => dispatch(startSetSymlinkCheck(token)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Symlink);
